import { shiftsTextFilter } from "./ShiftsContext";

export const ShiftsContextProvider = shiftsTextFilter.Provider;
export const ShiftsFilterInput = shiftsTextFilter.FilterInput;
